import type HighlightedRegionPropertiesDetailsSection from '~/components/Sections/HighlightedRegionPropertiesDetailsSection/HighlightedRegionPropertiesDetailsSection.vue';

import { breakpointsTailwind } from '@vueuse/core';

import { SECTION_TYPES } from '~/components/ContextualHeader';

import { useEvents } from './events/useEvents';

export const usePropertyContextualMenu = () => {
	const contactRef = useTemplateRef<HTMLElement>('contactRef');
	const locationRef = useTemplateRef<HTMLElement>('locationRef');
	const overviewRef = useTemplateRef<HTMLElement>('overviewRef');
	const mobileOverviewRef = useTemplateRef<HTMLElement>('mobileOverviewRef');
	const chosenForYouRef = useTemplateRef<HTMLElement>('chosenForYouRef');
	const heroSectionRef = useTemplateRef<HTMLElement>('heroSectionRef');
	const characteristicsRef = useTemplateRef<HTMLElement>('characteristicsRef');
	const propertyPricesRef = useTemplateRef<HTMLElement>('propertyPricesRef');
	const highlightedRegionPropertiesDetailsSectionRef = useTemplateRef<
		InstanceType<typeof HighlightedRegionPropertiesDetailsSection>
	>('highlightedRegionPropertiesDetailsSectionRef');

	const highlightedRegionPropertiesDetailsSectionEl = computed(
		() => highlightedRegionPropertiesDetailsSectionRef.value?.$el
	);

	const { isGreaterOrEqual } = useBreakpoints(breakpointsTailwind);

	const sectionRefs = computed(() => {
		const baseRefs = [characteristicsRef, locationRef, contactRef];
		const overviewElement = isGreaterOrEqual('md')
			? overviewRef
			: mobileOverviewRef;

		return [overviewElement, ...baseRefs];
	});

	useContextualHeaderVisibilityControl({
		heroSectionRef,
		sectionRefs: sectionRefs.value,
		anchorSection: highlightedRegionPropertiesDetailsSectionEl
	});

	const { trackMenuPropertyClicked } = useEvents();

	useEventBus<string>('tab-clicked').on(tabId => {
		trackMenuPropertyClicked({
			click_attributes: tabId.includes(SECTION_TYPES.CHARACTERISTICS),
			click_location: tabId.includes(SECTION_TYPES.LOCATION),
			click_overview: tabId.includes(SECTION_TYPES.OVERVIEW),
			click_service: tabId.includes(SECTION_TYPES.CONTACT)
		});
	});

	return {
		contactRef,
		locationRef,
		overviewRef,
		mobileOverviewRef,
		chosenForYouRef,
		heroSectionRef,
		characteristicsRef,
		propertyPricesRef
	};
};
